import type { ListNotificationsResponse } from "@/adapters/api";

export function markReadInCache(
	data: ListNotificationsResponse,
	id: string,
	readAt: string,
): ListNotificationsResponse {
	let changed = false;
	const items = data.items.map((notification) => {
		if (notification.id !== id || notification.read_at) {
			return notification;
		}
		changed = true;
		return { ...notification, read_at: readAt };
	});
	if (!changed) {
		return data;
	}
	return {
		...data,
		items,
		unread_count: Math.max(0, data.unread_count - 1),
	};
}

export function markAllReadInCache(
	data: ListNotificationsResponse,
	readAt: string,
): ListNotificationsResponse {
	return {
		...data,
		unread_count: 0,
		items: data.items.map((notification) =>
			notification.read_at ? notification : { ...notification, read_at: readAt },
		),
	};
}
